import { ICompanyMetadata } from '@epi-models/core/Layout';

export const getVoucherPageVisibility = (
  companyMetadata?: ICompanyMetadata,
  hasVouchers?: boolean
) => {
  if (!companyMetadata || companyMetadata?.hideVoucherOrder) {
    return false;
  }

  if (
    !companyMetadata?.hideVoucherOrder &&
    !companyMetadata.orderVouchersEnabled
  ) {
    return !!hasVouchers;
  }

  return true;
};
